import React from "react";
export default function PriceBar({ prices, coins }) {
  if (!prices || !coins) return null;
  return (
    <div style={{ display:"flex",gap:24,padding:"10px 20px",background:"#0a0c10",
      borderBottom:"1px solid #1e2433",overflowX:"auto" }}>
      {Object.keys(coins).map(sym => {
        const p = prices[sym]; if (!p) return null;
        const up = p.change_24h >= 0;
        return (
          <div key={sym} style={{ display:"flex",alignItems:"center",gap:8,whiteSpace:"nowrap" }}>
            <span style={{ width:8,height:8,borderRadius:"50%",background:coins[sym]?.color||"#888",display:"inline-block" }}/>
            <span style={{ fontWeight:700,fontSize:13 }}>{sym}</span>
            <span style={{ fontSize:14,fontWeight:600 }}>
              ${p.price.toLocaleString("en-US",{minimumFractionDigits:0,maximumFractionDigits:2})}
            </span>
            <span style={{ fontSize:12,color:up?"#22c55e":"#ef4444",fontWeight:600 }}>
              {up?"▲":"▼"}{Math.abs(p.change_24h).toFixed(2)}%
            </span>
          </div>
        );
      })}
    </div>
  );
}
